/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";

/* ERROR REPORTING */
export const SEND_ERROR_REPORT = "SEND_ERROR_REPORT";
export const SEND_ERROR_REPORT_SUCCESS = "SEND_ERROR_REPORT_SUCCESS";
export const SEND_ERROR_REPORT_ERROR = "SEND_ERROR_REPORT_ERROR";
